import {toLocalTime} from "../../../utils/timeUtils";
import React from "react";

interface DateSeparatorProps {
  timestamp: string;
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ timestamp }) => {
  const formatDateSeparator = (timestamp: string) => {
    const date = new Date(timestamp.includes('T') && !timestamp.endsWith('Z') ? timestamp + 'Z' : timestamp);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    } else {
      return toLocalTime(timestamp, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
      });
    }
  };

  return (
    <div className="flex items-center justify-center  py-4">
      <div className="px-3 py-1  text-xs bg-gray-50 dark:bg-gray-800 rounded-full text-gray-500 dark:text-gray-500  font-medium">
        {formatDateSeparator(timestamp)}
      </div>
    </div>
  );
};

export default DateSeparator;